import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../Sidebar/Sidebar";
import {
  Box,
  AppBar,
  Toolbar,
  Typography,
  CssBaseline,
  Drawer,
  IconButton,
} from "@mui/material";
import ListFood from "../List/ListFood";
import MenuIcon from "@mui/icons-material/Menu";
import { useState } from "react";
import { useAuth } from "../../../context/AuthContext";

const drawerWidth = 240;

export default function AdminLayout() {
  //access currentUser and logout from AuthContext
  const { currentUser} = useAuth();

  // get the username if currentUser exists
  const username = currentUser?.displayName;

  
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />

      {/* top AppBar */}
      <AppBar
        position="fixed"
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backgroundColor: "#034b94",
        }}
      >
        <Toolbar>
          {/* left-aligned menu icon for mobile */}
          <IconButton
            color="inherit"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>

          {/* left-aligned title */}
          <Typography variant="h5" noWrap sx={{ flexGrow: 1 }}>
            ADMIN DASHBOARD
          </Typography>
          {username ? (
            <>
              <Box
                sx={{
                  position: "absolute",
                  left: "50%",
                  transform: "translateX(-50%)",
                  display: { xs: "none", sm: "block" },
                }}
              >
                <Typography variant="h6">Hey Admin, [ {username} ]</Typography>
              </Box>

              <Box sx={{ ml: "auto" }}>
                <ListFood />
              </Box>
            </>
          ) : (
            <p>not logged in</p>
          )}
        </Toolbar>
      </AppBar>

      {/* sidebar */}
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="admin sidebar"
      >
        {/* mobile drawer */}
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          <Sidebar />
        </Drawer>

        {/* permanent drawer */}
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
          open
        >
          <Sidebar />
        </Drawer>
      </Box>

      {/* main content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          // p: 1,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
        }}
      >
        <Toolbar />
        <Outlet />
      </Box>
    </Box>
    
  );
}
